import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import {AutotextService} from '../autotext.service';
import { LoginService } from '../login.service';


@Component({
    selector: 'app-autotext-row',
    templateUrl: './autotext-row.component.html',
    styleUrls: ['./autotext-row.component.scss'],
    standalone: false
})
export class AutotextRowComponent implements OnInit {

  @Input('id') id: number;
  @Input('text') Text: string;
  @Input('priority') Priority: number;
  @Input('isFirst') isFirst: boolean = false;
  @Input('isLast') isLast: boolean = false;
  @Input('isClinic') isClinic: boolean = false;
  @Output() updated = new EventEmitter<null>();
  @Output() add = new EventEmitter<string>();
  @Output() priorityChanged = new EventEmitter<{id: number, priority: number}>();
  isChecked=false;
  edit: boolean = false;
  debounce=500;
  firstRow=false;

  constructor(public atS: AutotextService, public ls:LoginService) { }

  ngOnInit() {
    if(this.id == null) {
      this.setEdit();
      // Initialize priority for new autotext - will be auto-assigned on server
      if(this.Priority === undefined || this.Priority === null) {
        this.Priority = null; // Server will assign the correct priority
      }
    }
    if(this.Text == '')
      this.firstRow=true;
  }

  setEdit(){
    this.edit=true;
  }

  save(move = false){
    // When moving from clinic to user, set priority to null so server calculates it for user
    let priorityToSend = this.Priority;
    if(move && this.isClinic){
      // Moving from clinic to user - reset priority so it gets calculated for user context
      priorityToSend = null;
    }
    let res = this.atS.saveText(this.Text, this.id, move, priorityToSend, this.isClinic);
    res.subscribe((data)=>{
      if(this.id == null)
        this.id = data['insertId'];
        if(this.firstRow){
          this.Text = '';
          this.id = null;
        }
        this.updated.emit();

    },(error)=>{
      console.log(error);
    });
  }

  addText(){
    if(! this.isChecked)
      return;
    this.add.emit(this.Text);
  }

  delete(){
    this.atS.delete(this.id).subscribe((data)=>{
      this.updated.emit();
    },(error)=>{
      console.log(error);
    });
  }

  moveUp(){
    if(this.Priority !== undefined && this.Priority !== null && this.Priority > 0){
      // Move up means lower priority number (swap with item above)
      this.atS.updatePriority(this.id, this.Priority - 1, this.isClinic).subscribe((data)=>{
        this.updated.emit();
      },(error)=>{
        console.log(error);
      });
    }
  }

  moveDown(){
    if(this.Priority !== undefined && this.Priority !== null){
      // Move down means higher priority number (swap with item below)
      this.atS.updatePriority(this.id, this.Priority + 1, this.isClinic).subscribe((data)=>{
        this.updated.emit();
      },(error)=>{
        console.log(error);
      });
    }
  }


}
